export const subscriptionTypes = [
  'documentUpdated',
  'transportPlanUpdated',
  'shipmentCreated',
  'shipmentUpdated',
  'shipmentDeleted',
  'scheduledReportGenerated',
  'shipmentInvoiceCreated',
  'customsStatusUpdated',
  'mainCarriageDelay',
  'containerNumbersUpdate',
] as const

export type SubscriptionType = (typeof subscriptionTypes)[number]

export type Subscription = {
  id: string
  type: 'webhook'
  url: string
  eventTypes: SubscriptionType[]
  signatureKey: string
  name: string
}
